<template>
  <div role="form" action method="post">
    <div class="text-center">
      <h1 v-if="title">{{ $t(title) }}</h1>
    </div>

    <div class="f1-steps">
      <div class="f1-progress">
        <div class="f1-progress-line" :style="{ width: progressWidth + '%' }"></div>
      </div>

      <wizard-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :tab="tab"
        :active="isActive(tab)"
        :style="{ width: itemWidth + '%' }"
        @click="goToSelectedTab(index)"
      />
    </div>

    <slot />

    <footer v-if="!hideFooter">
      <div class="well wizard-footer">
        <button type="button" class="btn btn-default" @click="prev()">Poprzedni</button>

        <button type="button" class="btn btn-default float-right" @click="next()">Następny</button>
      </div>

      <div class="f1-buttons wizard-footer">
        <button type="submit" class="btn btn-primary">Zapisz</button>
      </div>
    </footer>
  </div>
</template>

<script>
import WizardTab from './Tab.vue';

// @vuese
// Kreator
// @group Wizard
export default {
  name: 'Wizard',
  props: {
    // Tytuł
    title: {
      type: String,
      required: false
    },
    // Lista etapów
    // Zakładki
    tabs: {
      type: Array,
      required: true
    },
    // Aktywny etap
    activeTab: {
      type: Number,
      default: 0
    },
    // Ukryty footer
    hideFooter: {
      type: Boolean,
      default: false
    },
    clickableTabs: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      submit: false
    };
  },
  components: { WizardTab },
  mounted() {
    this.setActiveSection(this.activeTab);
  },
  methods: {
    // @vuese
    // Sprawdza czy etap jest aktywny
    isActive(item) {
      return this.tabs.findIndex(x => x === item) <= this.activeTab;
    },
    // @vuese
    // Ustawia aktywną sekcję
    setActiveSection(sectionIndex) {
      if (sectionIndex < this.sections.length) {
        this.sections.forEach(section => (section.show = false));
        this.sections[sectionIndex].show = true;
      }
    },
    // @vuese
    // Przechodzi do następnej sekcji
    next() {
      if (this.activeTab + 1 < this.tabs.length) {
        this.$emit('nextTab');
      }
    },
    // @vuese
    // Wraca do poprzedniej sekcji
    prev() {
      if (this.activeTab - 1 >= 0) {
        this.$emit('previousTab');
      }
    },
    // @vuese
    // Sprawdza czy przejść do następnej zakładki
    goToSelectedTab(index) {
      if (this.clickableTabs) {
        this.$emit('setActiveTab', index);
      }
    }
  },
  computed: {
    activeItem() {
      if (this.activeTab < this.tabs.length) {
        return this.tabs[this.activeTab];
      }

      return undefined;
    },
    itemWidth() {
      const width = 100 / this.tabs.length;

      return width;
    },
    progressWidth() {
      if (this.submit) {
        return 100;
      }
      return this.itemWidth * this.activeTab + this.itemWidth / 2;
    },
    sections() {
      return this.$children.filter(child => child.$options._componentTag === 'wizard-section');
    }
  },
  watch: {
    activeTab(newValue) {
      this.setActiveSection(newValue);
    }
  }
};
</script>

<style>
.f1-progress-line {
  transition: width 0.3s ease;
}
.f1-step .f1-step-icon {
  transition: all 0.3s linear;
}
</style>
